module.exports = __webpack_public_path__ + "static/img/main6.8af0c306.png";